import React from 'react';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { theme } from './theme';

// CardFieldsGroup — new (Sep 1, per Ali's report). Replaces the single
// combined <CardElement> used identically in three separate files
// (PaymentMethodScreen.js, FreezePaymentModal.js,
// PinBundlePurchaseModal.js) — Stripe's default CardElement bundles
// card number, expiry, and CVC into one line, which read as a single
// confusing field rather than a normal, familiar checkout form and
// was flagged directly from a live screenshot. Split into Stripe's own
// CardNumberElement/CardExpiryElement/CardCvcElement instead — three
// genuinely separate, clearly labeled fields, still each rendering
// inside Stripe's own secure iframe exactly as before (raw card data
// never touches this app's state or backend either way).
//
// Built once as a shared component rather than fixing the same layout
// in three places separately, so all three payment surfaces stay
// visually identical going forward instead of drifting apart over
// future edits.
//
// International card brands (Amex, JCB, Diners, UnionPay, etc.) work
// automatically with all three of these elements — no extra
// configuration needed for that; this component is purely a layout
// change, not a payment-method-coverage change.
//
// Usage: mount this once, then in the parent's stripe.createPaymentMethod
// call, reference elements.getElement(CardNumberElement) as the card —
// Stripe automatically pulls in the linked CardExpiryElement/
// CardCvcElement values as long as all three are mounted inside the
// same <Elements> provider, no additional wiring needed.
const elementStyle = {
  style: {
    base: {
      fontSize: '14px',
      color: theme.textPrimary,
      '::placeholder': { color: theme.textMuted },
    },
  },
};

const fieldBoxStyle = {
  border: `2px solid ${theme.border}`,
  padding: '11px 12px',
};

const labelStyle = {
  display: 'block',
  fontSize: '12px',
  fontWeight: 700,
  color: theme.textMuted,
  marginBottom: '4px',
};

function CardFieldsGroup() {
  return (
    <div style={{ marginBottom: '14px' }}>
      <div style={{ marginBottom: '10px' }}>
        <label style={labelStyle}>Card number</label>
        <div style={fieldBoxStyle}>
          <CardNumberElement options={elementStyle} />
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <div>
          <label style={labelStyle}>Expiry date</label>
          <div style={fieldBoxStyle}>
            <CardExpiryElement options={elementStyle} />
          </div>
        </div>
        <div>
          <label style={labelStyle}>CVC</label>
          <div style={fieldBoxStyle}>
            <CardCvcElement options={elementStyle} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardFieldsGroup;